module.exports = __webpack_public_path__ + "static/media/Stormy_Ashamed.170cf84f.gif";